import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, TextField, Button, DialogTitle, DialogContent, DialogActions, Typography, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const SubCategoryForm = ({ selected, onSuccess, onCancel }) => {
  const [name, setName] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get('/api/categories').then(res => setCategories(res.data));
    if (selected) {
      setName(selected.name);
      setCategoryId(selected.category_id);
    } else {
      setName('');
      setCategoryId('');
    }
  }, [selected]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (selected) {
        await axios.put(`/api/categories/sub_categories/${selected.id}`, { name, category_id: categoryId });
      } else {
        await axios.post('/api/categories/sub_categories', { name, category_id: categoryId });
      }
      onSuccess();
      setName('');
      setCategoryId('');
    } catch (error) {
      console.error('Error saving sub-category:', error);
      alert('Failed to save sub-category');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1, 
        bgcolor: '#1976d2',
        color: 'white',
        fontSize: '1rem',
        py: 1.5
      }}>
        <SubdirectoryArrowRightIcon />
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
          {selected ? 'Edit Sub-Category' : 'Add New Sub-Category'}
        </Typography>
      </DialogTitle>
      
      <DialogContent dividers>
        <Box component="form" id="subcategory-form" onSubmit={handleSubmit} sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <TextField
            select
            value={categoryId}
            onChange={e => setCategoryId(e.target.value)}
            required
            label="Parent Category"
            fullWidth
            sx={{ 
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#1a237e',
                }
              }
            }}
          >
            <MenuItem value="">Select Category</MenuItem>
            {categories.map(cat => (
              <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
            ))}
          </TextField>

          <TextField
            fullWidth
            value={name}
            onChange={e => setName(e.target.value)}
            label="Sub-Category Name"
            placeholder="Enter sub-category name"
            required
            sx={{ 
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#1a237e',
                }
              }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ py: 1, px: 2, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'grey.50', gap: 1 }}>
        <Button 
          onClick={onCancel}
          variant="outlined"
          startIcon={<CancelIcon />}
          sx={{ 
            borderColor: '#757575',
            color: '#757575',
            '&:hover': {
              borderColor: '#424242',
              bgcolor: '#f5f5f5'
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          type="submit"
          form="subcategory-form"
          variant="contained" 
          disabled={loading}
          startIcon={selected ? <EditIcon /> : <AddIcon />}
          sx={{ 
            bgcolor: '#1976d2',
            fontSize: '0.75rem',
            py: 0.5,
            px: 1.5,
            '&:hover': {
              bgcolor: '#1565c0'
            }
          }}
        >
          {selected ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </>
  );
};

export default SubCategoryForm;
